<template>
  <el-col class="chart-module" :lg="$root.barWidth">
    <div
      class="sub-view"
      style="min-height: 240px; padding: 0; text-align: center"
    >
      <el-row style="background-color: #55BFE7; padding: 1px 5px 1px 5px; color: #fff">
        <span style="font-weight: bold; font-size: 13px; float: left">{{
          displayTitle
        }}</span>
        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.realTimeOnClose(title)"
        ></i>
      </el-row>
      <el-row
        style="
          text-align: center;
          font-size: 80px;
          color: #cc00ff;
          line-height: 170px;
        "
      >
        <span>{{$root.telSVDependCount}}</span>
      </el-row>
      <hr style="color: #f8f8f8; opacity: 0.5" />
      <el-row
        style="padding: 0 10px 0 10px; line-height: 22px; font-size: 12px"
      >
        <!-- <el-col class="opacity">{{ $root.htmlConst.cons_111_daily_count }}：{{dailySVCount}}</el-col> -->
        <!-- todo: do in the future -->
        <el-col class="opacity">{{ $root.htmlConst.cons_111_daily_count }}：0</el-col>
      </el-row>
    </div>
  </el-col>
</template>

<script>
import api from "@/api";
export default {
  name: "TelSupervisorHelpAlertCount",
  props: ["title", "displayTitle"],
  data() {
    return {
      dailySVCount: 0,
    };
  },
  created() {
    // <!-- todo: do in the future -->
    let self = this;
    api.getDailySVCount().then(
      (res) => {
        if (res && res.data) {
          self.dailySVCount = res.data.dailySVCount;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  },
};
</script>
<style>
.el-col-lg-4 {
  width: 16.666666%;
}
.el-col-lg-5 {
  width: 20%;
}
.el-col-lg-6 {
  width: 25%;
}
.el-col-lg-8 {
  width: 33.3333%;
}
</style>
